// User service to fetch user details from the server

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003';

// Get user details from server
export const getUserDetails = async (username: string) => {
  try {
    const response = await fetch(`${API_URL}/api/user-data?username=${encodeURIComponent(username)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.success) {
      return {
        success: false,
        message: data.message || 'Failed to fetch user details'
      };
    }

  return {
    success: true,
      message: 'User details fetched successfully',
      user: data.user
    };

  } catch (error) {
    console.error('Error fetching user details:', error);
    return {
      success: false,
      message: 'Network error occurred while fetching user details'
    };
  }
};

// Update user profile data
export const updateUserProfile = async (username: string, bzs_username: string) => {
  try {
    const response = await fetch(`${API_URL}/api/update-user-profile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
      username,
        bzs_username
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.success) {
      return {
        success: false,
        message: data.message || 'Failed to update user profile'
      };
    }

    return {
      success: true,
      message: data.message || 'Profile updated successfully',
      user: data.user
    };

  } catch (error) {
    console.error('Error updating user profile:', error);
    return {
      success: false,
      message: 'Network error occurred while updating profile'
    };
  }
}; 